import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import InvitePage from "@/pages/InvitePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import WeddingList from "@/pages/WeddingList";
import ThemeGalleryPage from "@/pages/ThemeGalleryPage";
import ThemePreviewPage from "@/pages/ThemePreviewPage";

function RequireAdmin({ children }) {
    const token = typeof window !== "undefined" ? localStorage.getItem("wd-admin-token") : null;
    if (!token) return <Navigate to="/admin/login" replace />;
    return children;
}

function LegacyInviteRedirect() {
    const { slug } = useParams();
    return <Navigate to={`/w/awady/i/${slug}`} replace />;
}

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Navigate to="/w/awady" replace />} />
                    <Route path="/w/:weddingSlug" element={<HomePage />} />
                    <Route path="/w/:weddingSlug/i/:guestSlug" element={<InvitePage />} />
                    <Route
                        path="/w/:weddingSlug/admin"
                        element={
                            <RequireAdmin>
                                <AdminDashboard />
                            </RequireAdmin>
                        }
                    />
                    <Route path="/i/:slug" element={<LegacyInviteRedirect />} />
                    <Route path="/themes" element={<ThemeGalleryPage />} />
                    <Route path="/themes/:themeId" element={<ThemePreviewPage />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <RequireAdmin>
                                <WeddingList />
                            </RequireAdmin>
                        }
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </LanguageProvider>
    );
}

export default App;
